document.addEventListener('DOMContentLoaded', () => {
    function setupVideoHover(container) {
      const video = container.querySelector('video');
      if (!video) return;
  
      container.addEventListener('mouseenter', () => {
        video.play();
      });
  
      container.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    }
  
    // Initial setup for existing elements
    document.querySelectorAll('.card--media').forEach(setupVideoHover);
  
    // Observe DOM for dynamically added .card--media
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return; // skip non-elements
  
          if (node.classList.contains('card--media')) {
            setupVideoHover(node);
          } else {
            // If it contains multiple card--media inside
            node.querySelectorAll?.('.card--media').forEach(setupVideoHover);
          }
        });
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
});